import { TZ_DISPLAY_MAP } from '../tz';

class TimeZoneService {

  constructor () {
    if(TimeZoneService.instance) {
      return TimeZoneService.instance;
    }

    TimeZoneService.instance = this;
  }

  getTimeZoneDisplay (tzid) {
    return TZ_DISPLAY_MAP[tzid];
  }

}


const instance = new TimeZoneService();
Object.freeze(instance);

export default instance;
